import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ children, isAuthenticated, ...rest }) => {
  return isAuthenticated === true ? <Outlet /> : <Navigate to="/" />;
};
export default ProtectedRoute;
